(function () {

  function parseJson(root, selector) {

    var el = (root || document).querySelector(selector);

    if (!el) return null;



    try {

      return JSON.parse(el.textContent);

    } catch (error) {

      return null;

    }

  }



  function normalizeValue(value) {

    return (value || '').toString().trim().toLowerCase();

  }



  function findVariantForOption(component, optionValue) {

    if (!component || !component.variants || !component.variants.length) return null;



    var target = normalizeValue(optionValue);

    if (!target) {

      return (

        component.variants.find(function (variant) {

          return variant.available !== false;

        }) || component.variants[0]

      );

    }



    return (

      component.variants.find(function (variant) {

        return normalizeValue(variant.title) === target;

      }) ||

      component.variants.find(function (variant) {

        return normalizeValue(variant.option1) === target;

      }) ||

      component.variants.find(function (variant) {

        var title = normalizeValue(variant.title);

        return title.indexOf(target) !== -1 || target.indexOf(title) !== -1;

      }) ||

      component.variants[0]

    );

  }



  function getProductSection() {

    return document.querySelector('[data-section-type="product"]');

  }



  function getProductForm() {

    var section = getProductSection();

    return section ? section.querySelector('.ProductForm') : document.querySelector('.ProductForm');

  }



  function getSelectedOptionsFromVariant(variant) {

    if (!variant) return [];

    return [variant.option1, variant.option2, variant.option3].filter(function (value) {

      return value != null && value !== '';

    });

  }



  function getSelectedOptionsFromForm() {

    var form = getProductForm();

    if (!form) return [];



    var values = [];

    var options = form.querySelectorAll('.ProductForm__Variants > .ProductForm__Option');



    options.forEach(function (optionEl) {

      var checked = optionEl.querySelector('input[name^="option-"]:checked');

      if (checked) {

        values.push(checked.value.trim());

        return;

      }



      var selectedValue = optionEl.querySelector('.ProductForm__SelectedValue');

      if (selectedValue) {

        values.push(selectedValue.textContent.trim());

      }

    });



    return values;

  }



  function getInitialSelectedOptions() {

    var productData = parseJson(document, '[data-product-json]');

    if (!productData || !productData.product || !productData.product.variants) return [];



    var selectedId = productData.selected_variant_id;

    var variant =

      productData.product.variants.find(function (item) {

        return item.id === selectedId;

      }) || productData.product.variants[0];



    return getSelectedOptionsFromVariant(variant);

  }



  function updateImageSlot(selector, index, src, alt) {

    document.querySelectorAll(selector + '="' + index + '"]').forEach(function (slot) {

      if (slot.tagName === 'IMG') {

        slot.src = src;

        slot.alt = alt;

        slot.removeAttribute('srcset');

      } else {

        slot.innerHTML =

          '<img class="BundleProductGallery__Image" data-bundle-gallery-slot="' +

          index +

          '" src="' +

          src +

          '" alt="' +

          alt.replace(/"/g, '&quot;') +

          '">';

      }

    });

  }



  function getBundleOptionNames() {
    var productData = parseJson(document, '[data-product-json]');
    if (!productData || !productData.product || !productData.product.options) return [];
    return productData.product.options;
  }

  function getComponentOptionIndex(component, optionNames) {
    if (!optionNames || !optionNames.length) return component.optionIndex || 0;

    var title = normalizeValue(component.title);
    var handle = normalizeValue((component.handle || '').replace(/-/g, ' '));

    for (var i = 0; i < optionNames.length; i += 1) {
      var optionName = normalizeValue(optionNames[i]);
      if (!optionName) continue;
      if (optionName === title || optionName.indexOf(title) !== -1 || title.indexOf(optionName) !== -1) {
        return i;
      }
      if (handle && (optionName.indexOf(handle) !== -1 || handle.indexOf(optionName) !== -1)) {
        return i;
      }
    }

    return typeof component.optionIndex === 'number' ? component.optionIndex : 0;
  }

  function initBundleGallery() {

    var data = parseJson(document, '[data-bundle-gallery-json]');

    if (!data || !data.components || !data.components.length) return;



    function renderGallery(selectedOptions) {

      var options = selectedOptions && selectedOptions.length ? selectedOptions : getSelectedOptionsFromForm();



      if (!options.length) {

        options = getInitialSelectedOptions();

      }



      data.components.forEach(function (component, index) {
        var optionIndex = getComponentOptionIndex(component, getBundleOptionNames());
        var optionValue = options[optionIndex] || component.defaultTitle;
        var variant = findVariantForOption(component, optionValue);
        if (!variant || !variant.image) return;

        var alt = component.title || '';
        updateImageSlot('[data-bundle-gallery-slot', index, variant.image, alt);
        updateImageSlot('[data-bundle-contents-slot', index, variant.image, alt);
      });

    }



    function scheduleRender(selectedOptions) {

      window.requestAnimationFrame(function () {

        renderGallery(selectedOptions);

      });

    }



    renderGallery();



    var section = getProductSection();

    if (section) {

      section.addEventListener('variant:changed', function (event) {

        var variant = event.detail && event.detail.variant;

        scheduleRender(getSelectedOptionsFromVariant(variant));

      });

    }



    document.addEventListener('variant:changed', function (event) {

      var variant = event.detail && event.detail.variant;

      scheduleRender(getSelectedOptionsFromVariant(variant));

    });



    document.addEventListener('change', function (event) {

      if (event.target && event.target.name && event.target.name.indexOf('option-') === 0) {

        scheduleRender();

      }

    });



    document.addEventListener('click', function (event) {

      if (

        event.target.closest('[data-action="select-value"]') ||

        event.target.closest('.VariantSelector__Item') ||

        event.target.closest('.VariantSelector__Choice') ||

        event.target.closest('.SizeSwatch__Radio') ||

        event.target.closest('.ColorSwatch__Radio')

      ) {

        setTimeout(function () {

          scheduleRender();

        }, 50);

      }

    });

  }



  function formatMoney(cents, format) {

    if (typeof cents !== 'number' || isNaN(cents)) return '';

    var value = (cents / 100).toFixed(2);

    if (!format) return '$' + value;



    return format

      .replace(/\{\{\s*amount\s*\}\}/g, value)

      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))

      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));

  }



  function initBundlePricing(root) {

    var data = parseJson(root, '[data-bundle-pricing-json]');

    if (!data) return;



    var separateEl = root.querySelector('[data-bundle-separate-total]');

    var badgeEl = root.querySelector('[data-bundle-savings-badge]');

    if (!separateEl || !badgeEl) return;



    function render(separateTotal) {

      var savings = separateTotal - data.bundlePrice;

      separateEl.textContent = formatMoney(separateTotal, data.moneyFormat);



      if (savings > 0) {

        var percent = Math.round((savings / separateTotal) * 100);

        badgeEl.textContent =

          'Save ' + formatMoney(savings, data.moneyFormat) + (percent > 0 ? ' (' + percent + '%)' : '');

        root.hidden = false;

      } else {

        root.hidden = true;

      }

    }



    render(data.separateTotal);



    document.addEventListener('variant:changed', function () {

      render(data.separateTotal);

    });

  }



  document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('[data-bundle-gallery-json]')) {

      initBundleGallery();

    }



    document.querySelectorAll('[data-bundle-pricing]').forEach(initBundlePricing);

  });

})();

